var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecordSaveLoading = function SvgRecordSaveLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.3,
    cy: 9.3,
    r: 8.3,
    stroke: "#D4D7DB",
    strokeWidth: 1.509
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#C77AC4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.509,
    d: "M1 9.3A8.3 8.3 0 1 0 9.3 1"
  })));
};
export default SvgRecordSaveLoading;